import { height, width, x, y } from './accessors.js';
import { BarCanvas } from '../../../../core/components/canvas/components/BarCanvas.js';
import { useGridPlotSize } from '../../../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { DEFAULT_FILL_OPACITY } from '../../../../core/constants.js';
import { safeGet } from '../../../../core/utils/safe-get.js';
import { BAR_CHART_DISPLAY_ARIA_LABEL } from '../../../constants.js';
import { useTimeseriesFilteredData } from '../../../hooks/useTimeseriesFilteredData.js';
import { useYScales } from '../../../hooks/useYScales.js';
import { TimeseriesBarSlotProps } from '../../../types/timeseries.js';
import { BaseDisplayProps } from '../shared/types.js';

export interface BarChartDisplayProps extends BaseDisplayProps {
  series: TimeseriesBarSlotProps[];
}

/**
 * Displays the passed series as stacked bar chart.
 */
export const BarChartDisplay = ({
  series: barSeries,
  xScale,
}: BarChartDisplayProps) => {
  const yScale = useYScales();
  const { width: widthPlot, height: heightPlot } = useGridPlotSize();
  const { seriesMap, datapointsMap } = useTimeseriesFilteredData();

  return (
    <figure aria-label={BAR_CHART_DISPLAY_ARIA_LABEL}>
      {barSeries.map((series) => {
        const seriesMetadata = safeGet(seriesMap, series);

        return (
          <BarCanvas
            key={seriesMetadata.id}
            data={series.datapoints}
            canvasWidth={widthPlot}
            canvasHeight={heightPlot}
            x={x(datapointsMap, xScale)}
            y={y(datapointsMap, yScale)}
            width={width(datapointsMap, xScale)}
            height={height(datapointsMap, yScale)}
            strokeWidth={1}
            color={() => seriesMetadata.color.Default}
            opacity={() => DEFAULT_FILL_OPACITY}
          />
        );
      })}
    </figure>
  );
};

BarChartDisplay['displayName'] = 'BarChartDisplay';
